import { render, staticRenderFns } from "./genericPopupResponseStatus.vue?vue&type=template&id=f4f0ec60&scoped=true&"
import script from "./genericPopupResponseStatus.vue?vue&type=script&lang=js&"
export * from "./genericPopupResponseStatus.vue?vue&type=script&lang=js&"
import style0 from "./genericPopupResponseStatus.vue?vue&type=style&index=0&id=f4f0ec60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f0ec60",
  null
  
)

export default component.exports